import { isWeb } from '@droplet-tech-code/core-elements/module/utils/utils.helper';
import { useEffect, useState } from 'react';

import { PageContainer, ScreenTwoPageLayout } from '~/components/Page/Page.Container';
import type { ScreenPropBookingsByName } from '~/navigation/Navigation.types';

import { BookingItem } from '../BookingItem';
import { BookingList, BookingListNative } from './Bookings.List';

export const BookingsByNameScreen = (props: ScreenPropBookingsByName) => {
  return (
    <PageContainer>
      <BookingsLayout {...props} />
    </PageContainer>
  );
};

export const BookingsLayout = (props: ScreenPropBookingsByName) => {
  const bookingId = props.route.params?.id;
  const { firstName, lastName } = props.route.params;

  const [id, setId] = useState<string | undefined>(props.route.params?.id);

  useEffect(() => {
    setId(bookingId);
  }, [bookingId]);

  return (
    <ScreenTwoPageLayout>
      {isWeb ? (
        <BookingList
          onPress={(item) => setId(item.id)}
          firstName={firstName}
          lastName={lastName}
        />
      ) : (
        <BookingListNative firstName={firstName} lastName={lastName} />
      )}
      {id ? <BookingItem bookingId={id} onClose={() => setId(undefined)} /> : <></>}
    </ScreenTwoPageLayout>
  );
};
